import { useRef, useState, useCallback } from "react";
import { ChevronsLeftRight } from "lucide-react";

export default function CompareSlider({ realSrc, aiSrc, alt, realLabel, aiLabel }) {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const update = useCallback((clientX) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    const pct = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.min(96, Math.max(4, pct)));
  }, []);

  const onPointerDown = (e) => {
    dragging.current = true;
    e.currentTarget.setPointerCapture?.(e.pointerId);
    update(e.clientX);
  };
  const onPointerMove = (e) => {
    if (dragging.current) update(e.clientX);
  };
  const stop = () => {
    dragging.current = false;
  };

  return (
    <div
      ref={ref}
      data-testid="founders-compare-slider"
      role="slider"
      aria-label={alt}
      aria-valuenow={Math.round(pos)}
      aria-valuemin={0}
      aria-valuemax={100}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "ArrowLeft") setPos((p) => Math.max(4, p - 4));
        if (e.key === "ArrowRight") setPos((p) => Math.min(96, p + 4));
      }}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={stop}
      onPointerCancel={stop}
      className="spotlight-frame relative aspect-[1088/997] cursor-ew-resize touch-none select-none overflow-hidden rounded-3xl focus:outline-none focus-visible:ring-2 focus-visible:ring-plz-orange"
    >
      <img src={aiSrc} alt={alt} draggable={false} className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={realSrc} alt="" draggable={false} className="absolute inset-0 h-full w-full object-cover" />
      </div>
      <div className="absolute inset-y-0 z-10 w-0.5 bg-plz-cream/90 shadow-[0_0_16px_rgba(7,12,27,0.6)]" style={{ left: `${pos}%` }}>
        <span className="absolute left-1/2 top-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-plz-line bg-plz-deep/90 text-plz-cream shadow-xl backdrop-blur">
          <ChevronsLeftRight className="h-5 w-5" aria-hidden="true" />
        </span>
      </div>
      <span className="absolute bottom-4 left-4 rounded-full bg-plz-deep/70 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-plz-cream backdrop-blur">
        {realLabel}
      </span>
      <span className="absolute bottom-4 right-4 rounded-full bg-plz-deep/70 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-plz-cream backdrop-blur">
        {aiLabel}
      </span>
    </div>
  );
}
